// src/Components/About/About.js
import React from 'react';
import Hero from '../Hero/Hero';

const Home = () => {
  return (
    <Hero />
  );
};

export default Home;